import {
  PRODUCT_CREATE_FAIL, PRODUCT_CREATE_REQUEST,
  PRODUCT_CREATE_SUCCESS, PRODUCT_DELETE_FAIL, PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS, PRODUCT_DETAILS_FAIL, PRODUCT_DETAILS_SUCCESS, PRODUCT_LIST_FAIL, PRODUCT_LIST_REQUEST, PRODUCT_LIST_SUCCESS,
  PRODUCT_SUSPEND_FAIL,
  PRODUCT_SUSPEND_REQUEST,
  PRODUCT_SUSPEND_SUCCESS,
  PRODUCT_UPDATE_FAIL, PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS
} from '../constants/productConstants';

// Reducer pour la liste de produits
export const productListReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return { loading: true, products: [] };
      case PRODUCT_LIST_SUCCESS:
        return {
          loading: false,
          products: action.payload.products,  // on stocke uniquement le tableau de produits
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          totalProducts: action.payload.totalProducts,
        };
      
    case PRODUCT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

    
export  const productDetailsReducer = (state = { product: {} }, action) => {
        switch (action.type) {
        case PRODUCT_DETAILS_SUCCESS:
            return { product: action.payload };
        case PRODUCT_DETAILS_FAIL:
            return { error: action.payload };
        default:
            return state;
        }
    };
    

    
    // Reducer pour créer un produit
    export const productCreateReducer = (state = {}, action) => {
      switch (action.type) {
        case PRODUCT_CREATE_REQUEST:
          return { loading: true };
        case PRODUCT_CREATE_SUCCESS:
          return { loading: false, success: true, product: action.payload };
        case PRODUCT_CREATE_FAIL:
          return { loading: false, error: action.payload };
        default:
          return state;
      }
    };
    
    // Reducer pour mettre à jour un produit
    export const productUpdateReducer = (state = { product: {} }, action) => {
      switch (action.type) {
        case PRODUCT_UPDATE_REQUEST:
          return { loading: true };
        case PRODUCT_UPDATE_SUCCESS:
          return { loading: false, success: true, product: action.payload };
        case PRODUCT_UPDATE_FAIL:
          return { loading: false, error: action.payload };
        default:
          return state;
      }
    };
    
    // Reducer pour supprimer un produit
    export const productDeleteReducer = (state = {}, action) => {
      switch (action.type) {
        case PRODUCT_DELETE_REQUEST:
          return { loading: true };
        case PRODUCT_DELETE_SUCCESS:
          return { loading: false, success: true };
        case PRODUCT_DELETE_FAIL:
          return { loading: false, error: action.payload };
        default:
          return state;
      }
    };
    



// Reinitialisation dans les reducers
export const productSuspendReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_SUSPEND_REQUEST:
      return { loading: true };
    case PRODUCT_SUSPEND_SUCCESS:
      return { loading: false, success: true };
    case PRODUCT_SUSPEND_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

